import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation, Trans } from "react-i18next";

import { DomainContext } from "../../../domain-repository/DomainRepository";

import { conventionOpenDoors } from "../keylessService";

import { KeylessModal } from "../components/KeylessModal";
import { KeylessButton } from "../components/KeylessButton";
import {
  KEYLESS_STEPS,
  KeylessPageLayout,
} from "../components/KeylessPageLayout";
import { errorModalImgStyle, keylessColors } from "../utils";
import { CONVENTION_STEPS, CONVENTION_TOKEN } from "./ConventionPage";

export function ConventionTelematica({
  handleNextStep,
  vehicleDetails,
}) {
  const { t } = useTranslation();

  const { localizationAssets } = useContext(DomainContext);

  const [isLoadingFinalSubmit, setIsLoadingFinalSubmit] = useState(false);
  const [keysModalOpen, setKeysModalOpen] = useState(false);
  const [errorModal, setErrorModal] = useState({ isOpen: false });

  const [isOpeningDoors, setIsOpeningDoors] = useState(false);

  const keylessOpenDoorsClick = useCallback(() => {
    setIsOpeningDoors(true);

    conventionOpenDoors(CONVENTION_TOKEN)
      .then((res) => {
        setKeysModalOpen(true);
      })
      .catch((err) => {
        setErrorModal({
          isOpen: true,
          title: "keylessWarning",
          message: "keylessVehicleKeysErrorMessage",
        });
      })
      .finally(() => setIsOpeningDoors(false));
  }, []);

  const finishKeylessSessionClick = useCallback(() => {
    handleNextStep(CONVENTION_STEPS.DONE);
  }, []);

  return (
    <KeylessPageLayout
      t={t}
      step={KEYLESS_STEPS.DOOR}
      localizationAssets={localizationAssets}
      reservationNumber={''}
      footer={
        <KeylessButton
          text={t("keylessOpenDoors")}
          color="white"
          onClick={keylessOpenDoorsClick}
          backgroundColor={keylessColors.orange}
          isLoading={isOpeningDoors}
        />
      }
    >
      <div style={styles.pageContent} className="container">
        <h1 style={styles.title}>{t("keylessVehicleDoorsTitle")}</h1>
        <h3 style={styles.subtitle}>{t("keylessVehicleDoorsSubTitle")}</h3>
        <img
          style={styles.vehicleImage}
          src={localizationAssets["keylessVehicleDoorsImage"]}
          alt=""
        />
        <div style={styles.filler} />
      </div>
      <KeylessModal
        isOpen={keysModalOpen}
        title={t("conventionDoorOpenedTitle")}
        img={localizationAssets["keylessVehicleKeysImage"]}
        imgHeight="140px"
        actions={
          <div style={styles.actions}>
            <KeylessButton
              text={t("yes")}
              onClick={finishKeylessSessionClick}
              isLoading={isLoadingFinalSubmit}
            />
            <KeylessButton
              text={t("no")}
              onClick={() =>
                setKeysModalOpen(false)
              }
              disabled={isLoadingFinalSubmit}
            />
          </div>
        }
      />
      <KeylessModal
        animation="slide-up"
        isOpen={errorModal.isOpen}
        title={t(errorModal.title)}
        message={
          <Trans
            i18nKey={errorModal.message}
            values={{
              stationPhoneNumber: '',
            }}
            components={[<br />]}
          />
        }
        img={localizationAssets["keylessError"]}
        imgStyle={errorModalImgStyle}
        actions={
          <div className="flex gap-4 items-center">
            <KeylessButton
              text={t("tryAgain")}
              onClick={() => {
                setErrorModal({
                  isOpen: false,
                })
                setKeysModalOpen(false);
              }}
            />
            <KeylessButton
              text={t("leave")}
              onClick={() => (window.location.href = "/")}
            />
          </div>
        }
      />
    </KeylessPageLayout>
  );
}

const styles = {
  page: {
    height: "100dvh",
    paddingBottom: "60px",
    fontFamily: "'BlissLight'",
  },
  pageContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: "1rem",
  },
  filler: {
    flex: 1,
  },
  title: {
    color: keylessColors.green,
    textAlign: "center",
    fontSize: "24px",
  },
  subtitle: {
    textAlign: "center",
    fontSize: "16px",
  },
  vehicleImage: {
    maxWidth: "400px",
    width: "70%",
    margin: "0 auto",
    display: "block",
  },
  actions: {
    display: "grid",
    gap: "1rem",
  },
};
